import type { FC } from "react";
import { usePortfolioRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { PortfolioDetailPageLegacy } from "web_myplann/Portfolio/Pages/PortfolioDetailPageLegacy";
import { PortfolioDetailPageRedesign } from "web_myplann/Portfolio/Pages/PortfolioDetailPageRedesign";
import { MyPlannLoading } from "web_myplann/Shared/Components/MyPlannLoading";

export const PortfolioDetailPage: FC = () => {
	const { hasRight: hasPortfolioRight, isPending } =
		usePortfolioRightOptional();

	if (isPending) {
		return <MyPlannLoading />;
	}

	return hasPortfolioRight ? (
		<PortfolioDetailPageRedesign />
	) : (
		<PortfolioDetailPageLegacy />
	);
};
